import { estimateStringWidth, ELLIPSIS } from '@shopify/polaris-viz-core';
import { formatAndAddEllipsis } from './formatAndAddEllipsis.js';

function truncateSingleLine({
  characterWidths,
  label,
  targetWidth
}) {
  const estimatedWidth = estimateStringWidth(label, characterWidths);

  if (estimatedWidth <= targetWidth) {
    return label;
  }

  const characters = label.split('');
  let width = 0;
  let newLabel = '';
  let index = 0;

  while (width <= targetWidth - characterWidths[ELLIPSIS]) {
    width += characterWidths[characters[index]];
    newLabel += characters[index];
    index++;
  }

  return formatAndAddEllipsis(newLabel);
}

export { truncateSingleLine };
